const trim = (value) => (value == null ? '' : String(value).trim());

const pick = (obj, ...keys) => {
  for (const key of keys) {
    const value = obj?.[key];
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return null;
};

export const parseUserProfile = (data) => {
  const source = data?.result ?? data ?? {};

  const firstName = trim(source.firstName);
  const lastName = trim(source.lastName);
  const fullName =
    trim(pick(source, 'fullName', 'FullName')) ||
    [firstName, lastName].filter(Boolean).join(' ');

  const status = trim(pick(source, 'status', 'Status')) || 'Pending';
  const statusLower = status.toLowerCase();
  const isAccountVerified = statusLower === 'approved' || Boolean(source.isAccountVerified);

  return {
    fullName: fullName || '—',
    email: trim(source.email),
    affiliateCode: trim(pick(source, 'affiliateCode', 'AffiliateCode', 'partnerCode', 'PartnerCode')),
    countryName: trim(source.countryName),
    countryCode: trim(source.countryCode),
    mobileNumber: trim(source.mobileNumber),
    state: trim(source.state),
    city: trim(source.city),
    zipCode: trim(source.zipCode),
    address: trim(source.address),
    lastCompanyName: trim(source.lastCompanyName),
    totalClients: trim(source.totalClients),
    totalTradingExp: trim(source.totalTradingExp),
    dateOfBirth: pick(
      source,
      'dateOfBirth',
      'DateOfBirth',
      'dob',
      'DOB',
      'birthDate',
      'BirthDate'
    ),
    status,
    partnerUrl: trim(pick(source, 'partnerUrl', 'PartnerUrl')),
    isEmailVerified: Boolean(source.isEmailVerified),
    isNumberVerified: Boolean(source.isNumberVerified),
    isAccountVerified,
    createdDateTime: pick(source, 'createdDateTime', 'CreatedDateTime', 'createdDate', 'CreatedDate'),
  };
};

/** Normalize API date values into yyyy-MM-dd for <input type="date" /> */
export const toDateInputValue = (value) => {
  if (!value) return '';
  if (/^\d{4}-\d{2}-\d{2}/.test(String(value))) return String(value).slice(0, 10);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const profileToEditForm = (profile) => ({
  state: profile?.state || '',
  city: profile?.city || '',
  zipCode: profile?.zipCode || '',
  address: profile?.address || '',
  lastCompanyName: profile?.lastCompanyName || '',
  totalClients: profile?.totalClients || '',
  totalTradingExp: profile?.totalTradingExp || '',
  dateOfBirth: toDateInputValue(profile?.dateOfBirth),
});

export const formatProfileDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const formatProfilePhone = (countryCode, mobileNumber) => {
  const mobile = trim(mobileNumber);
  if (!mobile) return '—';
  const code = trim(countryCode);
  if (!code || code === '0') return mobile;
  return `+${code.replace(/^\+/, '')} ${mobile}`;
};

export const getProfileInitials = (fullName) => {
  const parts = trim(fullName).split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return 'U';
};
